import React, { component } from 'react';
import Button from '../button/index';
import Modal from '.';
import { ModalBody, ModalFooter, ModalTitle } from './styles';
import TermosDeUsoTexto from '../legal/termosDeUsoTexto';

class ModalNew extends React.Component {
    constructor(props) {
        super(props);
    }

    styles = {
        control: provided => ({
            ...provided,
            padding: "15px"
        })
    };

    updateOk = () => {
        this.props.onHide();
    }



    render() {
        return (
            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
                width='60%'
            >
                <ModalTitle> TERMOS E CONDIÇÕES GERAIS DE USO </ModalTitle>

                <ModalBody>
                    <TermosDeUsoTexto />
                </ModalBody>

                <ModalFooter>
                    {this.props.btnOk == true ? (
                        <Button
                            style={{ outline: 0, padding: "10px", width: "100px", margin: "auto", marginTop: '15px' }}
                            color="#00b43f"
                            onClick={() => this.updateOk()}
                        >
                            ENTENDI
                        </Button>
                    ) : (null)}
                </ModalFooter>
            </Modal>

        );
    }
}
export default ModalNew;